import styled from 'styled-components';

export const PageWrapper = styled.div`
    width: 100%;
    min-height: 80vh;
    max-width: 1100px;
    margin: 0 auto;
    padding: 30px 20px 60px;

    @media (max-width: 768px) {
        padding: 20px 16px 40px;
    }
`;

export const BackButton = styled.button`
    background: transparent;
    border: 1px solid rgba(255, 255, 255, 0.15);
    color: rgba(255, 255, 255, 0.75);
    padding: 8px 16px;
    border-radius: 20px;
    font-size: 0.9rem;
    cursor: pointer;
    transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease;

    &:hover {
        background: rgba(255, 153, 0, 0.1);
        border-color: rgba(255, 153, 0, 0.4);
        color: var(--white-color);
    }

    &:focus-visible {
        outline: 2px solid var(--primary-color);
        outline-offset: 2px;
    }
`;

export const PageHeader = styled.div`
    text-align: center;
    max-width: 760px;
    margin: 30px auto 36px;

    @media (max-width: 768px) {
        margin: 20px auto 24px;
    }
`;

export const PageTitle = styled.h1`
    color: var(--white-color);
    font-size: 2rem;
    font-weight: 800;
    line-height: 1.2;
    margin: 0 0 12px 0;
    text-wrap: balance;

    @media (max-width: 768px) {
        font-size: 1.5rem;
    }
`;

export const PageSubtitle = styled.p`
    color: rgba(255, 255, 255, 0.65);
    font-size: 1.05rem;
    line-height: 1.5;
    margin: 0;

    @media (max-width: 768px) {
        font-size: 0.95rem;
    }
`;

export const CharactersGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 24px;
    margin: 0 auto;

    @media (max-width: 1024px) {
        grid-template-columns: repeat(2, 1fr);
        gap: 20px;
    }

    /* Mobile: mantém 2 colunas, com cards mais compactos */
    @media (max-width: 480px) {
        grid-template-columns: repeat(2, 1fr);
        gap: 12px;
    }
`;

export const CharacterCard = styled.div`
    background: linear-gradient(145deg, rgba(255, 255, 255, 0.06), rgba(255, 255, 255, 0.02));
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    border: 1.5px solid rgba(255, 255, 255, 0.1);
    border-radius: 20px;
    padding: 24px 18px;
    text-align: center;
    cursor: pointer;
    transition: transform 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease;
    display: flex;
    flex-direction: column;
    align-items: center;

    &:hover {
        transform: translateY(-6px);
        border-color: rgba(255, 153, 0, 0.55);
        box-shadow: 0 16px 40px rgba(255, 153, 0, 0.18);
    }

    &:focus-visible {
        outline: 2px solid var(--primary-color);
        outline-offset: 4px;
    }

    @media (max-width: 480px) {
        padding: 14px 10px;
        border-radius: 16px;
    }
`;

export const CharacterImage = styled.img`
    width: 180px;
    height: 180px;
    max-width: 100%;
    height: auto;
    border-radius: 16px;
    image-rendering: pixelated;
    image-rendering: -moz-crisp-edges;
    image-rendering: crisp-edges;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.35);
    margin-bottom: 16px;
    background: rgba(0, 0, 0, 0.2);

    @media (max-width: 480px) {
        border-radius: 12px;
        margin-bottom: 10px;
    }
`;

export const CharacterName = styled.h2`
    color: var(--white-color);
    font-size: 1.3rem;
    font-weight: 800;
    margin: 0 0 4px 0;

    @media (max-width: 480px) {
        font-size: 1.05rem;
    }
`;

export const CharacterRole = styled.p`
    color: rgba(255, 255, 255, 0.55);
    font-size: 0.88rem;
    margin: 0 0 14px 0;

    @media (max-width: 480px) {
        font-size: 0.78rem;
        margin: 0 0 10px 0;
    }
`;

export const CharacterCTA = styled.div`
    color: var(--primary-color);
    font-size: 0.92rem;
    font-weight: 700;
    margin-top: auto;
    padding-top: 4px;
    transition: transform 0.2s ease;

    ${CharacterCard}:hover & {
        transform: translateX(4px);
    }

    @media (max-width: 480px) {
        font-size: 0.8rem;
    }
`;
